export default function singleItemOrArray(array) {
    return array.length === 1 ? array[0] : array;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/chart/utils/single-item-or-array.js
// module id = 996
// module chunks = 29